import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { decorators, getPaginator } from '@orange-marmalade/paginate-this';
import { connect } from 'react-redux';
import { Button, Nav, NavItem } from 'reactstrap';
import numeral from 'numeral';

export function ViewResults(props, context) {
  const BS = context.theme;
  const { className, totalCount, onShowResults, tabIndex } = props;

  return (
    <Nav
      horizontal="space-between"
      className={cx(className, BS.w100, BS.alignItemsCenter)}
    >
      <NavItem className={`${BS.fontWeightBold}`}>
        {numeral(totalCount).format('0,0')} Results
      </NavItem>
      <Button
        onClick={onShowResults}
        type="submit"
        name="me"
        value="test"
        color="dark-blue"
        tabIndex={tabIndex}
      >
        View Results
      </Button>
    </Nav>
  );
}

ViewResults.contextTypes = {
  theme: PropTypes.object
};

export default decorators.paginateThis(
  connect((state, props) => ({
    totalCount: getPaginator(props.listId, state).get('totalCount')
  }))(ViewResults)
);



// WEBPACK FOOTER //
// ./src/components/paginator/view-results.js